export default {
    title: "English title",
    login: "Login",
    donate: "Donate",
    joinUs: "Join the garden",

    plant: {
        name: {
            label: "Taime nimi",
            uk: "Ukraina keeles",
            et: "Eesti keeles",
            en: "Inglise keeles",
            la: "Lastele"
        },

        latin: "Ladinakeelne taime nimi",
        description: {
            label: "Taime kirjeldused",
            uk: "Ukraina keeles",
            et: "Eesti keeles",
            en: "Inglise keeles",
            la: "Lastele"
        },
        pdf: {
            label: "Alla laetavad PDF dokumendid",
            uk: "Ukraina keeles",
            et: "Eesti keeles",
            en: "Inglise keeles",
            la: "Lastele"
        },

        audio: {
            label: "Kuulatavad heliklipid",
            uk: "Ukraina keeles",
            et: "Eesti keeles",
            en: "Inglise keeles",
            la: "Lastele"
        },

        image: "Taime pilt",
        author: "Teksti autor"
    },

    add_plant: "Add new plant",
    save: "Save",
    logout: "Log out",

    feedback: "Please share your thoughts",
    send: "Send",

    management: "Management",
    hildegard: "Hildegard",
    kogukonna_aed: "Community Garden",
    taimed: "Plants",

    download: {
        label: "Download PDF"
    }
}